import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import RouteState from '../../Recoil/RouteState';

const RoutePassListener = (props) => {

    let [routePass, setRoutePass] = useRecoilState(RouteState);
    let triggered = useRef(false);

    useEffect(() => {
        if (routePass && !triggered.current) {
            let link = JSON.parse(JSON.stringify(routePass));
            triggered.current = true;
            props.onTrigger(link);
            setTimeout(() => {
                triggered.current = false;
            }, 5000);
        }
    }, [routePass, props]);

    return (
        <></>
    );
}

export default RoutePassListener;